'use client';

import {
  useRateLimitOverlayStore,
  useRateLimitOverlayStoreBase,
} from 'app/_hook/useRateLimitOverlayStore/useRateLimitOverlayStore';
import { useEffect, useId, useState } from 'react';

export const RateLimitOverlay = () => {
  const { getValue } = useRateLimitOverlayStore();
  const resetAt = getValue('resetAt');
  const titleId = useId();
  const descId = useId();

  const [remainingMs, setRemainingMs] = useState<number>(() =>
    resetAt !== null ? Math.max(0, resetAt - Date.now()) : 0,
  );

  useEffect(() => {
    if (resetAt === null) return;

    setRemainingMs(Math.max(0, resetAt - Date.now()));

    const interval = setInterval(() => {
      setRemainingMs(Math.max(0, resetAt - Date.now()));
    }, 1000);

    return () => clearInterval(interval);
  }, [resetAt]);

  useEffect(() => {
    if (resetAt === null) return;

    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = original;
    };
  }, [resetAt]);

  if (resetAt === null) return null;

  const totalSeconds = Math.ceil(remainingMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const countdown = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

  const isExpired = remainingMs === 0;

  return (
    <div
      aria-describedby={descId}
      aria-labelledby={titleId}
      aria-modal='true'
      role='alertdialog'
      style={{
        alignItems: 'center',
        background: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        inset: 0,
        justifyContent: 'center',
        position: 'fixed',
        zIndex: 99999,
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 12,
          maxWidth: 360,
          padding: '32px 24px',
          textAlign: 'center',
          width: 'calc(100% - 48px)',
        }}
      >
        <h2
          id={titleId}
          style={{
            fontSize: 18,
            fontWeight: 700,
            lineHeight: 1.4,
            margin: '0 0 12px',
          }}
        >
          요청이 일시적으로 차단되었습니다
        </h2>

        <p
          id={descId}
          style={{
            color: '#555',
            fontSize: 14,
            lineHeight: 1.5,
            margin: '0 0 20px',
          }}
        >
          요청이 비정상적으로 여러번 발생하여 차단되었습니다.
        </p>

        <div
          style={{
            color: '#333',
            fontSize: 28,
            fontWeight: 700,
            margin: '0 0 24px',
          }}
        >
          {countdown}
        </div>

        <button
          disabled={!isExpired}
          onClick={() => {
            useRateLimitOverlayStoreBase.getState().actions.reload();
          }}
          style={{
            background: isExpired ? '#4f46e5' : '#c7c7c7',
            border: 'none',
            borderRadius: 8,
            color: '#fff',
            cursor: isExpired ? 'pointer' : 'not-allowed',
            fontSize: 14,
            fontWeight: 600,
            padding: '12px 24px',
            width: '100%',
          }}
          type='button'
        >
          {isExpired ? '새로고침' : '잠시만 기다려 주세요'}
        </button>
      </div>
    </div>
  );
};
